import { useState } from "react";
import api, { fmtErr, toastErr } from "../../api";
import { toast } from "sonner";

const inp = "field-input mt-1 w-full";

export function TermsPanel({ terms, termsLib, onChange, onLibChange, quoteType = "seasonal" }) {
  const [expandedTerm, setExpandedTerm] = useState(null);
  const [addOpen, setAddOpen] = useState(false);
  const [addMode, setAddMode] = useState("library");
  const [addLibId, setAddLibId] = useState("");
  const [addText, setAddText] = useState("");
  const [addSaveLib, setAddSaveLib] = useState(false);

  const moveTerm = (i, dir) => {
    const t = [...terms];
    const j = i + dir;
    if (j < 0 || j >= t.length) return;
    [t[i], t[j]] = [t[j], t[i]];
    onChange(t);
  };
  const addTerm = async () => {
    let newTerm;
    if (addMode === "library") {
      const t = [...(termsLib.standard || []), ...(termsLib.custom || [])].find((x) => x.id === addLibId);
      if (!t) return;
      newTerm = { term_id: t.id, text: t.text, on: true,
                  kind: (termsLib.standard || []).some((s) => s.id === t.id) ? "standard" : "custom" };
    } else {
      if (!addText.trim()) return;
      newTerm = { term_id: null, text: addText.trim(), on: true, kind: "oneoff" };
      if (addSaveLib) {
        const custom = [...(termsLib.custom || []), { text: addText.trim(), default_on: false, applies_to: "both" }];
        const r = await api.put("/quote-terms", { standard: termsLib.standard, custom })
          .catch((e) => { toastErr(e); return null; });
        if (r) {
          onLibChange?.(r.data);
          newTerm.term_id = r.data.custom[r.data.custom.length - 1].id;
          newTerm.kind = "custom";
        }
      }
    }
    onChange([...terms, newTerm]);
    setAddOpen(false); setAddText(""); setAddLibId("");
  };

  return (
    <div className="card-flat space-y-2 p-4" data-testid="terms-toggles">
      <p className="text-sm font-bold">Terms on this quote</p>
      {terms.map((t, i) => (
        <div key={t.term_id || i} className="rounded-md border border-border p-2" data-testid={`quote-term-${i}`}>
          <div className="flex items-center gap-2">
            <input type="checkbox" data-testid={`term-${i}-on`} checked={t.on !== false}
              onChange={(e) => onChange(terms.map((x, j) => (j === i ? { ...x, on: e.target.checked } : x)))} />
            <span className="flex-1 text-xs">{t.text.slice(0, 70)}{t.text.length > 70 ? "…" : ""}</span>
            <button data-testid={`term-${i}-up`} onClick={() => moveTerm(i, -1)} className="px-1 text-xs font-bold">↑</button>
            <button data-testid={`term-${i}-down`} onClick={() => moveTerm(i, 1)} className="px-1 text-xs font-bold">↓</button>
            <button data-testid={`term-${i}-expand`} onClick={() => setExpandedTerm(expandedTerm === i ? null : i)}
              className="px-1 text-xs font-bold text-primary">{expandedTerm === i ? "Done" : "Edit"}</button>
          </div>
          {expandedTerm === i && (
            <div className="mt-1">
              <textarea className="field-input w-full" rows={3} value={t.text} data-testid={`term-${i}-text`}
                onChange={(e) => onChange(terms.map((x, j) => (j === i ? { ...x, text: e.target.value } : x)))} />
              <p className="text-xs text-muted-foreground">Edits apply to this quote only.</p>
            </div>
          )}
        </div>
      ))}
      <button data-testid="add-term" onClick={() => setAddOpen(!addOpen)} className="text-xs font-bold text-primary">+ Add term</button>
      {addOpen && (
        <div className="space-y-2 rounded-md border-2 border-primary p-2" data-testid="add-term-panel">
          <div className="flex gap-2">
            <button data-testid="add-mode-library" onClick={() => setAddMode("library")}
              className={`flex-1 rounded border px-2 py-1 text-xs font-bold ${addMode === "library" ? "border-primary" : "border-border"}`}>From library</button>
            <button data-testid="add-mode-oneoff" onClick={() => setAddMode("oneoff")}
              className={`flex-1 rounded border px-2 py-1 text-xs font-bold ${addMode === "oneoff" ? "border-primary" : "border-border"}`}>One-off</button>
          </div>
          {addMode === "library" ? (
            <select data-testid="add-term-pick" className={inp} value={addLibId} onChange={(e) => setAddLibId(e.target.value)}>
              <option value="">Pick a term…</option>
              {[...(termsLib.standard || []), ...(termsLib.custom || [])]
                .filter((t) => !terms.some((x) => x.term_id === t.id))
                .filter((t) => ["both", quoteType].includes(t.applies_to || "both"))
                .map((t) => <option key={t.id} value={t.id}>{t.text.slice(0, 70)}…</option>)}
            </select>
          ) : (
            <>
              <textarea data-testid="add-term-text" className={inp} rows={2} value={addText} onChange={(e) => setAddText(e.target.value)} placeholder="Write the term…" />
              <label className="flex items-center gap-2 text-xs">
                <input type="checkbox" data-testid="add-term-save-lib" checked={addSaveLib} onChange={(e) => setAddSaveLib(e.target.checked)} />
                Save to library
              </label>
            </>
          )}
          <button data-testid="add-term-confirm" onClick={addTerm}
            className="h-9 w-full rounded-md bg-primary text-xs font-bold text-primary-foreground">Add to quote</button>
        </div>
      )}
    </div>
  );
}
